Foundation.Twitter.SessionManagerDelegate = function () {}

Foundation.Twitter.SessionManagerDelegate.prototype.sessionManagerID = function () {
  return "twitter"
}

Foundation.Twitter.SessionManagerDelegate.prototype.logOut = function () {
  return Foundation.Twitter.cleanCookie()
}

Foundation.Twitter.SessionManagerDelegate.prototype.revalidateLogin = function () {}
Foundation.Twitter.SessionManagerDelegate.prototype.observeExternalSessionEvents = function () {}
Foundation.Twitter.SessionManagerDelegate.prototype.unobserveExternalSessionEvents = function () {}

Foundation.Session.Manager.sharedInstance().registerDelegate(new Foundation.Twitter.SessionManagerDelegate())
